import React, { useMemo } from 'react'

import ErrorSnackbar from '../errorSnackbar'
import { getTourTypeName } from './contantsAndType'
import SchedultTourWayAndTime from './scheduleTourWayAndTime'
import SelectedForm from './selectedForm'
import VarsitySelectedForm from './varsitySelectedForm'

export default function SubmitTourPc({
  selfGuidTourUnits,
  prospectId,
  property,
  onChangeTime: setSelectedAgentTime,
  onBackNewUserId: setNewAdminUserId,
  onChangeType: setTourType,
  agentInfo,
  selectedUnits,
  selectedProperty,
  timeZoneInfo: selectedPropertyTimeZone,
  type: tourType,
  typeList: tourTypeList,
  isReschedule,
  setAddTourError,
  addTourError,
  isCentralizedStage,
  onNoAvailableDay,
  isVarsityProperty,
  selectedFloorPlans,
  setPageType,
}: any) {
  return (
    <div className="min-h-[calc(100vh-75px)] pt-5 pb-[95px] px-5">
      {isVarsityProperty ? (
        <VarsitySelectedForm isReschedule={isReschedule} selectedFloorPlans={selectedFloorPlans} setPageType={setPageType} />
      ) : (
        <SelectedForm selectedUnits={selectedUnits} property={property} tourOption={isReschedule ? getTourTypeName(tourType) : ''} />
      )}

      <SchedultTourWayAndTime
        selectedFloorPlans={selectedFloorPlans}
        isCentralizedStage={isCentralizedStage}
        prospectId={prospectId}
        typeList={tourTypeList}
        type={tourType}
        timeZoneInfo={selectedPropertyTimeZone}
        selectedUnits={selectedUnits}
        selectedProperty={selectedProperty}
        onChangeType={setTourType}
        agentInfo={agentInfo}
        onChangeTime={setSelectedAgentTime}
        isReschedule={isReschedule}
        onBackNewUserId={setNewAdminUserId}
        onNoAvailableDay={onNoAvailableDay}
      />
      <ErrorSnackbar setAddTourError={setAddTourError} addTourError={addTourError} />
    </div>
  )
}
